import ConnectRepository from '../Repositories/ConnectRepository';
import { setApiStatus } from './ApiStatusActions';
import { fetchJobDetails } from './CareerActions';
import { setVerifiedRecruiter } from '../Utility/inviteLink';

const connectRepository = new ConnectRepository();

function fetchConversation(conversationId, inviteToken) {
  return async (dispatch) => {
    dispatch(
      setApiStatus({
        apiName: 'getConversation',
        status: 'INPROGRESS',
      })
    );
    try {
      const conversationResponse = await connectRepository.getConversation(conversationId, inviteToken);
      const { data: conversation } = conversationResponse;
      setVerifiedRecruiter(conversation.UserEmail);
      const job = await fetchJobDetails(conversation.JobId);
      dispatch({
        type: 'GET_CONVERSATION',
        payload: { ...conversation, JobStatus: job ? job.Status : '' },
        conversationId,
      });
      dispatch(
        setApiStatus({
          apiName: 'getConversation',
          status: 'COMPLETED',
        })
      );
    } catch (error) {
      dispatch(
        setApiStatus({
          apiName: 'getConversation',
          // 401 is the invite endpoint's one refusal of a token: expired, forged and foreign alike.
          status: error?.response?.status === 401 ? 'REFUSED' : 'FAILED',
        })
      );
    }
  };
}

function clearConversation() {
  return {
    type: 'CLEAR_CONVERSATION',
  };
}

export { fetchConversation, clearConversation };
